//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/Dimensions.js";
let d=[[[0,"AngularSuppressZeros",1,0],[0,"ConvertPrimaryTolerance",1,0],[0,"DecimalPointCharacter",1,0],[0,"DimensionAngularFormat",1,0],[0,"DimensionLinearUnits",1,0],[0,"DimensionTolerancePlacement",1,0],[0,"DisplayLeadingDimensionZeros",1,0],[0,"DisplayLeadingToleranceZeros",1,0],[0,"DisplayTrailingZeros",1,0],[0,"DualDimensionCenterDimensionLine",1,0],[0,"DualDimensionFormat",1,0],[0,"DualDimensionUnits",1,0],[0,"DualFractionType",1,0],[0,"FractionalDisplay",1,0],[0,"LinearFractionType",1,0],[0,"NumeratorDegrees",1,0],[0,"NumeratorFraction",1,0],[0,"NumeratorMinutes",1,0],[0,"NumeratorSeconds",1,0],[0,"ToleranceAngularFormat",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.UnitsStyleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.UnitsStyleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;